module.exports = __webpack_public_path__ + "static/media/11.a3e19b5c.jpg";